import { Portal, PortalProps } from "@/components/portal/Portal";

export const PopupPortal = ({ children }: PortalProps) => {
  return <Portal root={"popup--portal--root"}>{children}</Portal>;
};
